import { render, staticRenderFns } from "./DepartAuthModal.vue?vue&type=template&id=58bd5e9e&scoped=true"
import script from "./DepartAuthModal.vue?vue&type=script&lang=js"
export * from "./DepartAuthModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bd5e9e",
  null
  
)

export default component.exports